"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeeplyOptimizedValue = exports.deepCopyCustomizations = void 0;
const _1 = require(".");
function deepCopyCustomizations(x) {
    const val = x;
    if (typeof val !== "object" || val === null) {
        return val;
    }
    if (_1.isCustoClass(val))
        return val;
    if (val instanceof Date) {
        return new Date(val);
    }
    const newVal = Array.isArray(val) ? [] : {};
    const keys = Object.keys(val);
    for (const key of keys) {
        newVal[key] = deepCopyCustomizations(val[key]);
    }
    return newVal;
}
exports.deepCopyCustomizations = deepCopyCustomizations;
exports.getDeeplyOptimizedValue = (oldValue, newValue, skipFn) => {
    if (oldValue === newValue)
        return newValue;
    if (typeof oldValue !== typeof newValue)
        return newValue;
    if (typeof oldValue !== "object" || oldValue === null)
        return newValue;
    if (skipFn) {
        const decision = skipFn(oldValue, newValue);
        if (!decision.skip) {
            if (decision.leaveOld)
                return oldValue;
            return newValue;
        }
    }
    const oldKeys = Object.keys(oldValue).sort();
    const newKeys = Object.keys(newValue).sort();
    const copiedNewVal = Array.isArray(newValue)
        ? [...newValue]
        : Object.assign({}, newValue);
    let canOldValueBeUsed = true;
    for (let i = 0; i < oldKeys.length; i++) {
        const key = oldKeys[i];
        if (key !== newKeys[i])
            canOldValueBeUsed = false;
        const oldPropValue = oldValue[key];
        const newPropValue = newValue[key];
        const newVal = exports.getDeeplyOptimizedValue(oldPropValue, newPropValue, skipFn);
        if (oldPropValue !== newVal)
            canOldValueBeUsed = false;
        copiedNewVal[key] = newVal;
    }
    if (oldKeys.length !== newKeys.length)
        canOldValueBeUsed = false;
    if (canOldValueBeUsed)
        return oldValue;
    return copiedNewVal;
};
